module.exports = __webpack_public_path__ + "play-button.png?38b4bbf402d00d83c7e696d2ecc87e24";


//////////////////
// WEBPACK FOOTER
// ./assets/img/play-button.png
// module id = 34
// module chunks = 0